import React, { useEffect, useState } from 'react';
import {
  Flex,
  Heading,
  Input,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import { credentials } from '../credentials';
import { useSearchParams } from 'react-router-dom';
import { cpfMask } from '../utils/mask';
import _ from 'lodash';

const Login = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [document, setDocument] = useState<string>('');
  const [points, setPoints] = useState<string>('');
  const [searchParams] = useSearchParams();

  const formBackground = useColorModeValue('gray.100', 'gray.700');
  const navigate = useNavigate();

  const checkCredentials = (email: string, password: string) => {
    setLoading(true);

    if (_.some(credentials, { email, password })) {
      navigate(`/home?name=${name}&document=${document}&points=${points}`);
    } else {
      alert('Credenciais inválidas, tente novamente.');
    }

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  useEffect(() => {
    const name = searchParams.get('name');
    const document = searchParams.get('document');
    const points = searchParams.get('points');

    setName(name || '');
    setDocument(cpfMask(document));
    setPoints(points || '');
  }, [searchParams]);

  return (
    <Flex h="100vh" alignItems="center" justifyContent="center">
      <Flex
        flexDirection="column"
        bg={formBackground}
        p={12}
        borderRadius={8}
        boxShadow="lg"
      >
        <Heading mb={6}>Matsuya | Matclub</Heading>
        <Input
          value={email}
          placeholder="unidade@matsuya.com.br"
          type="email"
          variant="filled"
          mb={3}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          value={password}
          placeholder="**********"
          type="password"
          variant="filled"
          mb={6}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          colorScheme="teal"
          loadingText="Carregando..."
          isLoading={loading}
          onClick={() => checkCredentials(email, password)}
        >
          Entrar
        </Button>
      </Flex>
    </Flex>
  );
};

export default Login;
